import { ActivatedRouteSnapshot } from '@angular/router';
import { routerNavigatedAction } from '@ngrx/router-store';
import { createReducer, createSelector, on } from '@ngrx/store';
import { ActivateBreadcrumb, AppendBreadcrumb, AppendBreadcrumbs } from '../actions/breadcrumb.actions';
import { AppState } from '../store';
import { RouteData } from 'src/app/shared/constants-and-enums/route-data';

export interface BreadcrumbItem {
    text: string;
    onClick: string | VoidFunction;
}

export interface BreadcrumbState {
    breadcrumbs: BreadcrumbItem[];
}

export const initialState: BreadcrumbState = {
    breadcrumbs: []
};

export const breadcrumbReducer = createReducer(
    initialState,

    on(routerNavigatedAction, (state, { payload }) => ({ ...state, breadcrumbs: buildBreadcrumbs([], payload.routerState.root) })),
    on(AppendBreadcrumb, (state, { breadcrumb }) => ({ ...state, breadcrumbs: state.breadcrumbs.concat(breadcrumb) })),
    on(AppendBreadcrumbs, (state, { breadcrumbs }) => ({ ...state, breadcrumbs: [...state.breadcrumbs, ...breadcrumbs] })),
    on(ActivateBreadcrumb, (state, { breadcrumb, currentRoute }) => {
        const index = state.breadcrumbs.indexOf(breadcrumb);

        if (index >= state.breadcrumbs.length - 1 || index === -1) {
            return { ...state };
        } else if (currentRoute === breadcrumb.onClick) {
            // If the new route is the same as the current one, don't replace the breadcrumbs
            return { ...state };
        }

        return { ...state, breadcrumbs: state.breadcrumbs.slice(0, index + 1) };
    })
);

export const breadcrumbState = (state: AppState) => state.breadcrumbState;
export const breadcrumbs = createSelector(breadcrumbState, (state) => state.breadcrumbs);

// helper functions
function buildBreadcrumbs(breadcrumbs: BreadcrumbItem[], routeSnapshot: ActivatedRouteSnapshot): BreadcrumbItem[] {
    const children: ActivatedRouteSnapshot[] = routeSnapshot.children;

    if (children.length === 0) {
        return;
    }

    for (const child of children) {
        const routeData: RouteData = child.data;
        if (!!routeData.breadcrumb && !breadcrumbs.includes(routeData.breadcrumb)) {
            breadcrumbs.push(routeData.breadcrumb);
        } else if (!!routeData.breadcrumbs) {
            const breadcrumbsThatAreNotInList = routeData.breadcrumbs.filter((breadcrumb) => !breadcrumbs.includes(breadcrumb));
            breadcrumbs.push(...breadcrumbsThatAreNotInList);
        }

        buildBreadcrumbs(breadcrumbs, child);
    }

    return breadcrumbs;
}
